import { stringify } from 'query-string';
import { apiFetch } from './utils/api';

// const mockedPeriodicIndices = require('./mocks/v3/periodic-index.json');

export const periodicIndices = {
  get: async (args) => {
    const options = {
      method: 'GET',
    };

    const query = stringify(args, { arrayFormat: 'comma' });
    const url = `v3/portfolio/periodic-index?${query}`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
